import {faCirclePlus,} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ActionIcon,Menu,Popover} from "@mantine/core";
import React, {useState} from "react";
import {KpiQuery, QueryCardProp} from "../../../../../../types/types";
import {ConfirmPopUp} from "../modal/confirmPopUp";
import {SqlModal} from "../modal/sqlModal";
import "./queryCard.css";

export function QueryCard(props: Partial<QueryCardProp>) {
    const [openModal, setOpenModal] = useState(false);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [openedDescription, setOpenedDescription] = useState(false);

    function getConfirmation() {
        setOpenConfirmModal(true);
    }

    function deleteQueryCard() {
        let index = -1;
        props.props?.kpiInfo.configuration.queries && props.props?.kpiInfo.configuration.queries.forEach((queryInfo: KpiQuery, currIndex: number) => {
            if (queryInfo.name === props.name) {
                index = currIndex;
            }
        });
        props.props?.kpiInfo.configuration.queries && props.props?.kpiInfo.configuration.queries.splice(index, 1);
        props.forceUpdate();
    }

    function editQuery() {
        setOpenModal(true);
    }

    const capitalize = (str: string, lower = false) =>
    (lower ? str.toLowerCase() : str).replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());

    function makeTitle(title: string) {
        return capitalize(title.replace("_", " "));
    }

    return (
        <div className={"query-card"}>
            <div className={"query-card-header"}>
                <div className={"query-card-title"}>
                    { props.plus ? makeTitle("Add new query") : makeTitle(props.name!)}
                </div>
                {!props.plus &&
                    <div className={"zoom pointer"}>
                        <Menu>
                            <Menu.Label>Settings</Menu.Label>
                            <Menu.Item component="a" onClick={editQuery}>
                                Edit KPI
                            </Menu.Item>
                            <Menu.Item component="a" onClick={getConfirmation}>
                                Delete KPI
                            </Menu.Item>
                        </Menu>
                    </div>
                }
                
            </div>

            <div className={"query-card-content"}>
                {!props.plus &&
                    <Popover
                        opened={openedDescription}
                        onClose={() => setOpenedDescription(false)}
                        onMouseEnter={() => setOpenedDescription(true)}
                        onMouseLeave={() => setOpenedDescription(false)}
                        position="left"
                        placement="center"
                        withArrow
                        trapFocus={false}
                        closeOnEscape={false}
                        transition="pop-top-left"
                        width={540}
                        styles={{body: {pointerEvents: 'none'}}}
                        target={
                            <div>
                                <p className={"query-card-content-text"}>{props.query}</p>
                            </div>
                        }
                    >
                        <div style={{display: 'flex'}}>
                            {props.query}
                        </div>
                    </Popover>
                    
                }
                {props.plus &&
                <div className="queryCard-plus">
                    <ActionIcon>
                        <FontAwesomeIcon title="Add Query" onClick={props.openSqlTextEditor} icon={faCirclePlus}/>
                    </ActionIcon>
                </div>
                }
            </div>
            <SqlModal edit={true} queryName={props.name} query={props.query} props={props.props as any}
                      openModal={openModal} setOpenModal={setOpenModal} forceUpdate={props.forceUpdate}/>
            <ConfirmPopUp deleteQueryCard={deleteQueryCard} openConfirmModal={openConfirmModal}
                          setOpenConfirmModal={setOpenConfirmModal}
                          message="Are you sure you want to delete this query?" buttonPlaceHolder="Confirm"/>
        </div>
    );
}
